export { default } from "./KYCsteps";
